// extracted by mini-css-extract-plugin
module.exports = {"dark":"#172b49","light":"#f4f5fd","blue":"#66a3ff"};